// extracted by mini-css-extract-plugin
export var container = "contact-module--container--02a2B";
export var flex_container = "contact-module--flex_container--vdZbn";